export default __webpack_public_path__ + "static/media/services-cards.fe077991.png";